var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { from } from 'rxjs';
import { HTTP_CORS_MODE, HTTP_CREDENTIALS, HTTP_METHOD } from './types';
import { HttpURL } from "./HttpURL";
import { map } from 'rxjs/operators';
import { fetchTransport } from "./fetchTransport";
// TODO: ResponseParser
// TODO: ERROR ResponseParser
// TODO: Headers
// TODO: more config, credentials mode and etc
// TODO: Errors
// TODO: tokenManager
// TODO: set token manager and transport
// TODO: refactoring transport to class
var HttpService = /** @class */ (function () {
    function HttpService(config) {
        var _this = this;
        this.execute = (function (payload) {
            var _a, _b;
            var headers = {};
            var body = (_a = _this.config.body) === null || _a === void 0 ? void 0 : _a.encode(payload);
            if (body) {
                headers['Content-Type'] = (_b = _this.config.body) === null || _b === void 0 ? void 0 : _b.getType();
            }
            return from(_this.transport({
                url: _this.getUrl(payload),
                method: _this.config.method || HTTP_METHOD.GET,
                headers: headers,
                credentials: HTTP_CREDENTIALS.OMIT,
                mode: HTTP_CORS_MODE.CORS,
                body: body
            })).pipe(map(function (res) {
                return {
                    status: res.status,
                    response: res.body
                };
            }));
        });
        var defaultConfig = {
            method: HTTP_METHOD.GET
            // isErrorResponse: defaultIsErrorResponse
        };
        this.config = __assign(__assign({}, defaultConfig), config);
        this.transport = config.transport || fetchTransport;
    }
    HttpService.prototype.getUrl = function (payload) {
        var baseUrl = this.config.url.toString(payload);
        if (!this.config.query) {
            return baseUrl;
        }
        var queryList = Array.isArray(this.config.query)
            ? this.config.query
            : [this.config.query];
        var query = queryList
            .filter(Boolean)
            .map(function (i) { return i.toString(payload); })
            .join('&');
        return baseUrl + "?" + query.replace(/^\?+/, '');
    };
    HttpService.URL = HttpURL;
    return HttpService;
}());
export { HttpService };
//# sourceMappingURL=HttpService.js.map